/* Page to display each the image full size   */ 
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from 'react-bootstrap';
import Card from "react-bootstrap/Card";
import styles from "../styles/Indexes.module.css";
import btnStyles from "../styles/Button.module.css";
import { useHistory } from 'react-router-dom';

const Fullshot = ({image}) => {
    // console.log(image);
    const history = useHistory();

    const [isImage, setIsImage] = useState(false);

    const getContentTypeWithGET = async (image) => {
    const res = await fetch(image, { method: 'GET', cache: 'no-store' });
    return res.headers.get('Content-Type');
    };

    const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
    };

    useEffect(() => {
          if (image) {
            getContentTypeWithGET(image)
              .then((type) => {
                const isImage = isImageFile(type);
                setIsImage(isImage);
              })
              .catch((err) => {
                setIsImage(false);
              });
          } else {
            setIsImage(false); 
          }

      }, [image,]);

    return (
        <div>
            <Button
                className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
                onClick={() => history.goBack()}
                >
                Back
            </Button>
            <Card className={`text-center mb-5 mx-md-3`}  >
                <Card.Header className={`pt-2 pb-1 ${styles.TopCard }`}>
                  </Card.Header>
                  <Card.Body >
                    <Row>
                    {image && (
                    <Col xs={12} className={`text-center px-0 mx-0 mb-5`}>
                        {isImage ? (
                          <Card className="shadow-sm h-100 mx-3 mx-md-5">
                          <Card.Body className={`text-center px-md-5 `}  >
                            <figure className="m-0 p-0 text-center">
                            <Card.Img
                                src={image}
                                alt={`image`}
                                width="100%"
                                style={{
                                maxHeight: "600px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                }}
                            />
                            </figure>
                          </Card.Body>
                        </Card>
                        ) : (<>
                            <iframe
                            src={image}
                            width="100%"
                            title="fullshot"
                            allow="fullscreen"
                            height="600px"
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding: "1rem",
                            }}
                            />
                        </>
                        )}
                    </Col>
                    )}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Fullshot